module.exports = __webpack_public_path__ + "img/updateDownloadBg.bb86e214.png";